/**
 * Dialable-number rules shared by the softphone dial pad and the call-back
 * button. They mirror VoiceController::normalizeDialable() on the backend so
 * a number the browser lets through is one Twilio will actually be asked to
 * dial, and one it refuses never leaves a silent "failed" row behind.
 *
 * Accepted: an explicit +country number, or a US number written any of the
 * usual ways (ten digits, or eleven starting with 1, with any punctuation).
 * Anything else -- client identities, SIP URIs, withheld caller IDs, partial
 * numbers -- is refused rather than guessed at.
 */

export const DIAL_HINT =
  "Enter a 10-digit US number, or an international number starting with +.";

const ALLOWED_CHARACTERS = /^\+?[\d\s().-]+$/;

export function normalizeDialable(input: string): string | null {
  const value = input.trim();

  if (!ALLOWED_CHARACTERS.test(value)) return null;

  const digits = value.replace(/\D/g, "");

  if (value.startsWith("+")) {
    return /^[1-9]\d{7,14}$/.test(digits) ? `+${digits}` : null;
  }

  if (/^[2-9]\d{9}$/.test(digits)) return `+1${digits}`;
  if (/^1[2-9]\d{9}$/.test(digits)) return `+${digits}`;

  return null;
}
